import React, { useMemo } from 'react';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { useCart } from 'frontastic';
import Preview from '../wrapper';
import { DateHelpers } from 'helpers/dateHelpers';
const ShippingPreview = () => {
  const { ctLocale: locale } = useLocale();

  const { data, shippingMethods } = useCart();

  const shippingMethod = useMemo(() => {
    if (!data?.shippingInfo) return;

    let description;
    if (data?.shippingInfo?.name) {
      description = shippingMethods?.data?.find((sm) => sm.name === data?.shippingInfo?.name)?.description;
    }
    return {
      name: data?.shippingInfo?.name ?? '',
      price: data?.shippingInfo.price,
      description: description,
      deliveryDate: data?.custom?.deliveryDate ?? '',
    };
  }, [data, shippingMethods?.data]);

  // const getEstimatedDate = useCallback((days: number) => {
  //   if (isNaN(days)) return '';

  //   const date = new Date(Date.now());

  //   date.setDate(date.getDate() + days);

  //   return date.toLocaleDateString().replace(/\//g, '-');
  // }, []);

  return (
    <Preview>
      <div className="border border-neutral-400 p-16">
        <div className="flex items-center justify-between border-l-4 border-ag_color-text_green py-18 pl-18">
          <div>
            <p className="text-14 font-medium">{shippingMethod?.name}</p>
            <p className="mt-4 text-14 font-light text-secondary-black">
              {shippingMethod?.deliveryDate
                ? DateHelpers.formatDateVerbose(shippingMethod.deliveryDate)
                : shippingMethod?.description}{' '}
            </p>
          </div>

          <span className="text-14 font-medium">
            {CurrencyHelpers.formatForCurrency(shippingMethod?.price ?? {}, locale)}
          </span>
        </div>
      </div>
    </Preview>
  );
};

export default ShippingPreview;
